import React from "react";
import { Card, Typography } from "@material-ui/core";

import { css } from "./styles";

export const InstructionsCard = () => {
    const styles = css();

    return (
        <Card className={styles.instructions_card}>
            <Typography className={styles.title}>
                <b>ATENÇÃO</b>
            </Typography>
            <Typography>Para realizar a inclusão do produto, siga os seguintes passos:</Typography>

            <ol style={{ marginLeft: "20px" }}>
                <li style={{ listStyleType: "decimal" }}>
                    <Typography>Adicione o alfa numérico do primeiro grupo de produtos;</Typography>
                </li>

                <li style={{ listStyleType: "decimal" }}>
                    <Typography>
                        Selecione os IDS dos produtos referentes ao alfa adicionado no ponto 1;
                    </Typography>
                </li>

                <li style={{ listStyleType: "decimal" }}>
                    <Typography>Adicione um novo alfa e repita o processo.</Typography>
                </li>
            </ol>
        </Card>
    );
};
